import { render, staticRenderFns } from "./PageVideoTest.vue?vue&type=template&id=393f6237&scoped=true"
import script from "./PageVideoTest.vue?vue&type=script&lang=js"
export * from "./PageVideoTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393f6237",
  null
  
)

export default component.exports